'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _NotFound = require('./components/NotFound.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_NotFound).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/not-found/lib/index.js
// module id = 140
// module chunks = 1